export function removePortalElement(portalId: string) {
    const portalElement = document.getElementById(portalId);

    if (!portalElement || !portalElement.parentNode) {
        return;
    }

    portalElement.parentNode.removeChild(portalElement);
}
